<template>
  <v-row no-gutters class="text-body-2 pb-2">
    <researcher-avatar :researcher="researcher" small />
    <div class="ml-2">
      <div class="font-weight-medium">
        <template v-if="isResolution">Resolved this as</template>
        <template v-else>Voted this as</template>
        <v-icon
          class="material-icons-outlined mx-1"
          small
          :color="iconColor"
        >
          {{ icon }}
        </v-icon>
        <span class="font-weight-bold">{{ text }}</span>
      </div>
      <div class="time-caption font-weight-light grey--text">
        {{ dateText }}
      </div>
    </div>
  </v-row>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import moment, { Moment } from 'moment';
import { Researcher } from '@/models';
import { RelevanceAssessment } from '@/enums';

const VOTE_TO_PROPS = {
  [RelevanceAssessment.RELEVANT]: {
    icon: 'thumb_up_alt',
    iconColor: 'success',
    text: 'Relevant',
  },
  [RelevanceAssessment.NOT_RELEVANT]: {
    icon: 'thumb_down_alt',
    iconColor: 'error',
    text: 'Not Relevant',
  },
  [RelevanceAssessment.NOT_SURE]: {
    icon: 'help',
    iconColor: 'warning',
    text: 'Not Sure',
  },
};

export default {
  name: 'VoteLogItem',
  components: { ResearcherAvatar },
  props: {
    researcher: {
      type: Researcher,
      // May be null when the voter has been deleted; ResearcherAvatar shows a
      // "Deleted user" placeholder in that case.
      default: null,
    },
    vote: {
      type: String,
      default: null,
    },
    resolution: {
      type: String,
      default: null,
    },
    date: {
      type: Moment,
      default: () => moment(),
    },
  },
  computed: {
    isResolution() {
      return !!this.resolution;
    },
    assessment() {
      return this.vote || this.resolution;
    },
    icon() {
      return VOTE_TO_PROPS[this.assessment].icon;
    },
    iconColor() {
      return VOTE_TO_PROPS[this.assessment].iconColor;
    },
    text() {
      return VOTE_TO_PROPS[this.assessment].text;
    },
    dateText() {
      return this.date.format('hh:mm DD MMM');
    },
  },
};
</script>

<style lang="scss" scoped>
.time-caption {
  font-size: 10px;
}
</style>
